import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-basket-capacity-dialog',
  templateUrl: './basket-capacity-dialog.component.html',
  styleUrls: ['./basket-capacity-dialog.component.scss']
})
export class BasketCapacityDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<BasketCapacityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) { }

  closeDialog(success?: boolean): void {
    this.dialogRef.close(success);
  }

}
